import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {
  i18nizeDate,
  getStatusColor,
  mapStatus,
  mapTicketDepartment,
} from '../../../../helpers/Utils';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, omit} from 'lodash';
import {Link} from 'react-router-dom';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
    };
    this.renderDepartmentFilter = this.renderDepartmentFilter.bind(this);
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/tickets',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        tickets: data.tickets.map(ticket => ticket[0]),
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('Email'),
      accessor: 'email',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Title'),
      accessor: 'title',
    },
    {
      Header: t('Department'),
      accessor: 'section',
      filterable: true,
      width: 140,
      Filter: this.renderDepartmentFilter,
      Cell: props => <span>{mapTicketDepartment(props.value)}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      width: 130,
      Filter: this.renderStatusFilter,
      Cell: props =>
        <span className={getStatusColor(props.value)}>
          {mapStatus(props.value === 'PENDING' ? 'REPLY_WAITING' : props.value)}
        </span>,
    },
    {
      Header: t('Register Date'),
      accessor: 'createdAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Update Date'),
      accessor: 'updatedAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('View'),
      width: 80,
      Cell: props => <Link to={{
        pathname: '/dashboard/tickets/' + props.original.threadId,
      }}
      > <i className="simple-icon-eye view-icon"/> </Link>,
    },
  ];

  renderDepartmentFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'CUSTOMER_SUPPORT', label: mapTicketDepartment('CUSTOMER_SUPPORT')},
      {value: 'TECHNICAL', label: mapTicketDepartment('TECHNICAL')},
      {value: 'MANAGEMENT', label: mapTicketDepartment('MANAGEMENT')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'PENDING', label: mapStatus('REPLY_WAITING')},
      {value: 'REPLIED', label: mapStatus('REPLIED_OR_CLOSED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.tickets}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
